import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup
} from '@material-ui/core';
import React from 'react';

export default ({ field, ...props }) => {
  return (
    <FormControl>
      <FormLabel>{props.label}</FormLabel>
      <RadioGroup
        row
        {...field}
        value={field.value || ""}
        onClick={(e) => {
          let value = e.target.value;

          if (field.value == value) value = "";

          props.form.setFieldValue(field.name, value);
        }}
      >
        {props.options.map((option, i) => {
          return (
            <FormControlLabel
              key={i}
              value={option}
              control={<Radio color="primary" />}
              label={option.charAt(0).toUpperCase() + option.slice(1)}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};
